import React from 'react';
import { Box, BoxExtendedProps, MissingDetailIcon, Text } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  testId?: string;
  title?: string;
}

const WarningMessage: React.FC<Props> = ({ testId, title, ...props }) => {
  return (
    <Box
      data-testId={`${testId}_warning-message_wrapper`}
      direction="row"
      align="center"
      pad="spacing16"
      background="missingContainer"
      round="container2Round"
      {...props}
    >
      <MissingDetailIcon
        data-testId={`${testId}_warning-message_icon`}
        color="missingDetail"
        size="24px"
      />
      <Text
        data-testId={`${testId}_warning-message_title`}
        margin={{ left: 'spacing8' }}
      >
        {title}
      </Text>
    </Box>
  );
};

export default WarningMessage;
